var _ellipse, _path, _path2, _ellipse2, _ellipse3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "india",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.03,
    height: 32.03,
    viewBox: "0 0 32.03 32.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 16.015,
    cy: 15.756,
    rx: 16.015,
    ry: 15.756,
    transform: "translate(0)",
    fill: "#f0f0f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M39.646,0A15.8,15.8,0,0,0,25.4,9.052H53.89A15.8,15.8,0,0,0,39.646,0Z",
    transform: "translate(-23.761)",
    fill: "#ff9811"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M39.646,376.356A15.8,15.8,0,0,0,53.89,367.3H25.4A15.8,15.8,0,0,0,39.646,376.356Z",
    transform: "translate(-23.761 -344.326)",
    fill: "#6da544"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 5.5,
    cy: 5.57,
    rx: 5.5,
    ry: 5.57,
    transform: "translate(10.385 10.445)",
    fill: "#0052b4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 3.438,
    cy: 3.482,
    rx: 3.438,
    ry: 3.482,
    transform: "translate(12.448 12.534)",
    fill: "#f0f0f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M200.2,187.326l1.061,2.436,2.613-.288-1.553,2.148,1.553,2.148-2.613-.288-1.061,2.436-1.061-2.436-2.613.288,1.553-2.148-1.553-2.148,2.613.288Z",
    transform: "translate(-184.315 -175.607)",
    fill: "#0052b4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.013b352b05756ccd34281b51301508b9.svg";
export { ForwardRef as ReactComponent };